export const types = {
  CONVERTDATETOSTRING:'CONVERT-DATE-TO-STRING',
  MODIFYDATE:'MODIFY-DATE',
  CONVERTDATETOTIMESTAMP:'CONVERT-DATE-TO-TIMESTAMP'
}